import { render, staticRenderFns } from "./ModalView.vue?vue&type=template&id=8bedaf30&scoped=true&"
import script from "./ModalView.vue?vue&type=script&lang=js&"
export * from "./ModalView.vue?vue&type=script&lang=js&"
import style0 from "./ModalView.vue?vue&type=style&index=0&id=8bedaf30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bedaf30",
  null
  
)

component.options.__file = "ModalView.vue"
export default component.exports